<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.pending_review_withdrawal") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12
                .d-inline-block
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="$options.refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
              .form-group.col-3
                b-input-group(size="sm")
                  b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                    option(value="operator" v-if="!isOperator") {{ $t('ui.operator') }}
                    option(value="member" v-else-if="isOperator") {{ $t('ui.member') }}
                    option(value="ticket") {{ $t('ui.ticket') }}
                  template(v-if="['operator'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                  template(v-else-if="['member'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList()" size="sm")
                  template(v-if="['ticket'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
              .form-group.col-3(v-if="['operator'].includes(searchType) && operatorID != ''")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-12
                ul#tickettab.nav.nav-tabs(role='tablist')
                  li.nav-item
                    a#withdrawal-tab.nav-link.active(data-toggle='tab' href='#withdrawal-content' role='tab' aria-controls='withdrawal' aria-selected='false')
                      span {{ $t("ui.withdrawal") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ wdwTotalRow }}
                  li.nav-item
                    a#review-tab.nav-link(data-toggle='tab' href='#review-content' role='tab' aria-controls='review' aria-selected='false')
                      span {{ $t("ui.dd_review") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ revTotalRow }}

                #tickettabcontent.tab-content.tab-bordered
                  #withdrawal-content.tab-pane.active.show(role='tabpanel' aria-labelledby='withdrawal-tab')
                    .card
                      .card-body
                        .row
                          .col-10.mb-1
                            b-pagination.float-left(
                              size="sm"
                              hide-ellipsis
                              :total-rows="wdwTotalRow"
                              :per-page="getPageSize"
                              v-model="currentWdwPage"
                              @input="changedWdwPage($event)").mb-1
                          .col-md-2.mb-1
                            b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedWdwPageSize" size="sm")
                          .col-12
                            .clusterize-scroll.table-responsive
                              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                                thead.thead-light
                                  tr
                                    th.text-center(width="3%")
                                      span #
                                    th(width="5%" @click="sortOrder('id')")
                                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                      .float-right
                                        i(:class="changeSortKey('id')")
                                    th(width="8%")
                                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                    th.text-right(width="7%")
                                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                    th(width="17%")
                                      span(:title="$t('ui.recipient_bank')") {{ $t('ui.recipient_bank') }}
                                    th.text-center(v-if="isEditAccess" width="8%")
                                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                                tbody.clusterize-content
                                  tr(v-if="withdrawalList.length == 0")
                                    td(:colspan="isEditAccess ? '7' : '6'").text-center
                                      span {{ $t('message.no_data_available') }}
                                  tr(v-for="(item, index) in withdrawalList")
                                    td.text-center
                                      span(:title="((currentWdwPage - 1) * getPageSize + index + 1)") {{ ((currentWdwPage - 1) * getPageSize + index + 1) }}
                                    td
                                      span(:title="item.id") {{ item.id }}
                                    td
                                      span.d-block(:title="item.account_id") {{ item.account_id }}
                                      span.text-warning(:title="item.operator_id") {{ item.operator_id }}
                                    td.text-right
                                      span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                    td
                                      span(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}
                                      br
                                      span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
                                      br
                                      span(:title="item.recipient_bank_acc_holder") {{ item.recipient_bank_acc_holder }}
                                      template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                                        br
                                        span(:title="item.recipient_bank_acc_remark") {{ item.recipient_bank_acc_remark }}
                                      template(v-if="['AUD'].includes(getCurrencyCode)")
                                        br
                                        span(:title="item.recipient_bank_acc_remark_2") {{ item.recipient_bank_acc_remark_2 }}
                                    td.text-center(v-if="isEditAccess")
                                      span(v-if="item.status.trim().toUpperCase() != 'PENDING'")
                                        a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                                      //- span(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                      //-   a.fa.fa-check.btn.btn-ssm.btn-success(href="javascript:void(0)" @click="approveTicket(item)" :title="$t('ui.approve')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                        a.fa.fa-eye.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="reviewTicket(item, $event)" :title="$t('ui.dd_review')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                        a.fa.fa-check-double.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="auditTicket(item, $event)" :title="$t('ui.audit')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                        a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                                    td.text-right
                                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

                  #review-content.tab-pane(role='tabpanel' aria-labelledby='review-tab')
                    .card.mb-0
                      .card-body
                        .row
                          .col-10.mb-1
                            b-pagination.float-left(
                              size="sm"
                              hide-ellipsis
                              :total-rows="revTotalRow"
                              :per-page="getPageSize"
                              v-model="currentRevPage"
                              @input="changedRevPage($event)").mb-1
                          .col-2.mb-1
                            b-input-group(:prepend="$t('ui.page_size')" size="sm")
                              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedRevPageSize" size="sm")
                          .col-12
                            .clusterize-scroll.table-responsive
                              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                                thead.thead-light
                                  tr
                                    th.text-center(width="3%")
                                      span #
                                    th(width="5%")
                                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                    th(width="8%" @click="sortOrder('member_id')")
                                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                      .float-right 
                                        i(:class="changeSortKey('member_id')")
                                    th.text-right(width="7%" @click="sortOrder('amount')")
                                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                      .float-right 
                                        i(:class="changeSortKey('amount')")
                                    //- th(width="5%" @click="sortOrder('target_bank_id')")
                                    //-   span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                                    //-   .float-right 
                                    //-     i(:class="changeSortKey('target_bank_id')")
                                    //- th(width="8%" @click="sortOrder('target_bank_acc_no')")
                                    //-   span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                                    //-   .float-right 
                                    //-     i(:class="changeSortKey('target_bank_acc_no')")
                                    th(width="17%")
                                      span(:title="$t('ui.recipient_bank')") {{ $t('ui.recipient_bank') }}
                                    th.text-center(width="6%" @click="sortOrder('status')")
                                      span(:title="$t('ui.status')") {{ $t("ui.status") }}
                                      .float-right 
                                        i(:class="changeSortKey('status')")
                                    th.text-center(v-if="isEditAccess" width="8%")
                                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                    th.text-right(width="10%" @click="sortOrder('created_date')")
                                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                                      .float-right 
                                        i(:class="changeSortKey('created_date')")
                                tbody.clusterize-content
                                  tr(v-if="reviewList.length == 0")
                                    td(:colspan="isEditAccess ? '8' : '7'").text-center
                                      span {{ $t('message.no_data_available') }}
                                  tr(v-for="(item, index) in reviewList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                                    td.text-center
                                      span(:title="((currentRevPage - 1) * getPageSize + index + 1)") {{ ((currentRevPage - 1) * getPageSize + index + 1) }}
                                    td
                                      span(:title="item.id") {{ item.id }}
                                    td
                                      span.d-block(:title="item.account_id") {{ item.account_id }}
                                      span.text-warning(:title="item.operator_id") {{ item.operator_id }}
                                    td.text-right
                                      span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                    td
                                      span(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}
                                      br
                                      span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
                                      br
                                      span(:title="item.recipient_bank_acc_holder") {{ item.recipient_bank_acc_holder }}
                                      template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                                        br
                                        span(:title="item.recipient_bank_acc_remark") {{ item.recipient_bank_acc_remark }}
                                      template(v-if="['AUD'].includes(getCurrencyCode)")
                                        br
                                        span(:title="item.recipient_bank_acc_remark_2") {{ item.recipient_bank_acc_remark_2 }}
                                    td.text-center
                                      span.font-weight-bold(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                    td.text-center(v-if="isEditAccess")
                                      span
                                        a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                                      span.ml-1(v-if="item.status.trim().toUpperCase() == 'REVIEW'")
                                        a.fa.fa-check-double.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="auditTicket(item, $event)" :title="$t('ui.audit')")
                                      //- span.ml-1(v-if="item.status.trim().toUpperCase() == 'AUDIT'")
                                      //-   a.fa.fa-check.btn.btn-ssm.btn-success(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                                      span.ml-1
                                        a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                                    td.text-right
                                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}



    ticketdetailfcp(ref="ticketdetailfcp" :ticketDetail="selectedTicket" @failed="handleFailed")
    rejectticketfcp(ref="rejectticketfcp" :ticketDetail="selectedTicket" @clicked="afterRejectTicket" @failed="handleFailed")
    //- manualapproveticketaffiliate(ref="manualapproveticketaffiliate" :ticketId="selectedTicketId" @clicked="afterApproveTicket" @failed="handleFailed")
    reviewticketfcp(ref="reviewticketfcp" :ticketId="selectedTicketId" @clicked="afterReviewTicket" @failed="handleFailed")
    auditticketfcp(ref="auditticketfcp" :ticketId="selectedTicketId" @clicked="afterAuditTicket" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import rejectticketfcp from "@/components/freecreditprovider/rejectTicketFcp.vue";
import ticketdetailfcp from "@/components/freecreditprovider/ticketDetailFcp.vue";
// import manualapproveticketaffiliate from "@/components/affiliate/manualApproveTicketAffiliate.vue";
import reviewticketfcp from "@/components/freecreditprovider/reviewTicketFcp.vue";
import auditticketfcp from "@/components/freecreditprovider/auditTicketFcp.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    rejectticketfcp,
    ticketdetailfcp,
    // manualapproveticketaffiliate
    reviewticketfcp,
    auditticketfcp,
  },
  data: () => ({
    loading: false,
    withdrawalList: [],
    reviewList: [],
    currentWdwPage: 1,
    currentRevPage: 1,
    wdwTotalRow: 0,
    revTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    selectedTicket: null,
    selectedTicketId: null,
    sortKey: "id",
    sortType: "desc",
    ticketId: "",
    searchType: "ticket",
    operatorID: "",
    memberID: "",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_pendingticketaffiliatefree");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    this.getTicketList();
  },
  destroyed: function() {
    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    }
  },
  methods: {
    resetInput() {
      this.operatorID = "";
      this.memberID = "";
      this.ticketId = "";
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getWithdrawalList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getTicketDetail: function(e) {
      this.selectedTicket = e;
      this.$refs.ticketdetailfcp.$refs.ticketDetailFcp.show();
    },
    getTicketList() {
      this.getWithdrawalList(true);
      this.getReviewList(true);
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListPendingFreeUrl();

      if (isSearch) this.currentWdwPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentWdwPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.account_id = this.memberID
      } else {
        json.ticket_id = this.ticketId
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.wdwTotalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getReviewList: function(isSearch) {
      let url = config.ticketListReviewAuditFreeUrl();

      if (isSearch) this.currentRevPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        page_number: this.currentRevPage,
        page_size: this.getPageSize,
        ticket_status: "REVIEW"
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.account_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reviewList = response.data.dt;
                this.revTotalRow = this.reviewList.length > 0 ? this.reviewList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },    
    reviewTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.reviewticketfcp.$refs.reviewTicketFcp.show();
    },
    rejectTicket: function(e) {
      this.selectedTicket = e;
      this.$refs.rejectticketfcp.$refs.rejectTicketFcp.show();
    },
    // approveTicket: function(e) {
    //   this.selectedTicketId = e.id;
    //   this.$refs.manualapproveticketaffiliate.$refs.manualApproveTicketAffiliate.show();
    // },
    auditTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.auditticketfcp.$refs.auditTicketFcp.show();
    },
    afterRejectTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.reject_fcp_ticket"), this.$t("message.success"), "success");
    },
    // afterApproveTicket: function() {
    //   this.getTicketList();
    //   this.$helpers.showDialog(this.$t("ui.combine.approve_affiliate_ticket"), this.$t("message.success"), "success");
    // },
    afterAuditTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.audit_fcp_ticket"), this.$t("message.success"), "success");
    },
    afterReviewTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.review_fcp_ticket"), this.$t("message.success"), "success");
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedWdwPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentWdwPage = 1;
      this.getWithdrawalList(true);
    },
    changedWdwPage: function(pageNo) {
      this.currentWdwPage = pageNo;
      this.getWithdrawalList();
    },
    changedRevPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentRevPage = 1;
      this.getReviewList(true);
    },
    changedRevPage: function(pageNo) {
      this.currentRevPage = pageNo;
      this.getReviewList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
